import { AxiosResponse } from "axios";
import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import * as actions from "./actions";
import * as actionTypes from "./actionTypes";
import * as types from "./types";
import * as services from "./service";
import * as alert from "../alert/actions";

function* deleteSubscriptionSaga(action: types.DeleteSubscriptionRequest) {
  const timestamp = new Date().toLocaleString();
  try {
    const response: AxiosResponse<types.IDeleteSubscriptionSuccessPayload | types.IApiError> = yield call(services.deleteSubscriptions, action.params);

    if (response.status === 204) {
      yield put(
        actions.deleteSubscriptionSuccess({
          isSuccess: true,
        })
      );

      yield put(alert.enqueueSnackbar({ message: `You have unsubscribed from this ${action.subscriptionType.toLowerCase()}. Timestamp: ${timestamp}`, options: { variant: "success" } }));

    }

    //Show IApiError
    if (response.status !== 204) {
      let apiError = response.data as types.IApiError;
      let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
      yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
    }

  } catch (e: any) {
    yield put(
      actions.deleteSubscriptionFailure({
        error: e,
      })
    );
  }
}


function* postSubscriptionsSaga({ payload }: types.PostSubscriptionRequest) {
  const timestamp = new Date().toLocaleString();
  try {
    const response: AxiosResponse<types.IPostSubscriptionSuccess | types.IApiError> =
      yield call(services.postSubscription, payload);

    if (response.status === 201) {
      let dataPayload = response.data as types.IPostSubscriptionSuccess;
      yield put(
        actions.postSubscriptionSuccess({
          subscription: dataPayload,
        })
      );
      let successMsg = `Target subscription successful. Timestamp: ${timestamp}`;
      yield put(
        alert.enqueueSnackbar({
          message: successMsg,
          options: { variant: "success" },
        })
      );
    }

    if (response.status !== 201) {
      let apiError = response.data as types.IApiError;
      let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
      yield put(
        alert.enqueueSnackbar({
          message: errMsg,
          options: { variant: "error" },
        })
      );
    }
  } catch (e: any) {
    yield put(
      actions.postSubscriptionFailure({
        error: e,
      })
    );
  }
}


function* postExtractorSubscriptionsSaga({ batchCode, payload }: types.PostExtractorSubscriptionRequest) {
  const timestamp = new Date().toLocaleString();
  try {
    const response: AxiosResponse<types.IPostExtractorSubscriptionSuccess | types.IApiError> =
      yield call(services.postExtractorSubscription, batchCode, payload);

    if (response.status === 201) {
      let dataPayload = response.data as types.IPostExtractorSubscriptionSuccess;
      yield put(
        actions.postExtractorSubscriptionSuccess({
          subscription: dataPayload,
        })
      );
      let successMsg = `Extractor subscription successful. Timestamp: ${timestamp}`;
      yield put(
        alert.enqueueSnackbar({
          message: successMsg,
          options: { variant: "success" },
        })
      );
    }

    if (response.status !== 201) {
      let apiError = response.data as types.IApiError;
      let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
      yield put(
        alert.enqueueSnackbar({
          message: errMsg,
          options: { variant: "error" },
        })
      );
    }
  } catch (e: any) {
    yield put(
      actions.postExtractorSubscriptionFailure({
        error: e,
      })
    );
  }
}


//Subscription List 
function* fetchSubscriptionListSaga(action: types.FetchSubscriptionReq) {
  const timestamp = new Date().toLocaleString();
  try {
    const response: AxiosResponse<types.ISubscriptionDetails[]> = yield call(
      services.getSubscriptionDetails,
      action.params
    );

    yield put(
      actions.fetchSubscriptionSuccess({
        subscription: response.data as types.ISubscriptionDetails[],
      })
    );
  } catch (e: any) {
    yield put(
      alert.enqueueSnackbar({
        message: `Could not load subscription. Timestamp: ${new Date().toLocaleString()}`,
        options: { variant: "error" },
      })
    );
  }
}

function* fetchSubscriptionSaga() {
  yield takeLatest(actionTypes.FETCH_SUBSCRIPTION_LIST_REQUEST, fetchSubscriptionListSaga);
}

function* postSubscriptionSaga() {
  yield takeLatest(actionTypes.POST_SUBSCRIPTION_REQUEST, postSubscriptionsSaga);
}

function* postExtractorSubscriptionSaga() {
  yield takeLatest(actionTypes.POST_EXTRACTOR_SUBSCRIPTION_REQUEST, postExtractorSubscriptionsSaga);
}

function* delSubscriptionSaga() {
  yield takeEvery(actionTypes.DELETE_SUBSCRIPTION_REQUEST, deleteSubscriptionSaga);
}


function* subscriptionSaga() {
  yield all([delSubscriptionSaga(), postSubscriptionSaga(), postExtractorSubscriptionSaga(), fetchSubscriptionSaga()]);
}

export default subscriptionSaga;